import { render, staticRenderFns } from "./ExtraAdd.vue?vue&type=template&id=71449028&scoped=true&"
import script from "./ExtraAdd.vue?vue&type=script&lang=js&"
export * from "./ExtraAdd.vue?vue&type=script&lang=js&"
import style0 from "./ExtraAdd.vue?vue&type=style&index=0&id=71449028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71449028",
  null
  
)

export default component.exports